export const CivilStatus = {
  SINGLE: 'S',
  MARRIED: 'C'
} as const

export type CivilStatus = (typeof CivilStatus)[keyof typeof CivilStatus]

export const CivilStatusLabel = {
  [CivilStatus.SINGLE]: 'Soltero',
  [CivilStatus.MARRIED]: 'Casado'
} as const satisfies Record<CivilStatus, string>
